export const aboutMy = `
Matka Urszula Ledóchowska urodziła się 17 kwietnia 1865 roku w Loosdorf w Austrii i otrzymała na chrzcie świętym imię Julia.
Jej rodzice Antoni Ledóchowski oraz Józefina Salis-Zizers:
Jej rodzeństwo:
Już od najmłodszych lat (o. Włodziwierz Ledóchowski - brat - wspomina, że mogła mieć zaledwie 9 lat) myślała by zostać zakonnicą. 
W roku 1883 rodzina Julii powraca na ziemie polskie i osiedla się w Lipnicy Murowanej niedaleko Krakowa. Tam młoda Julia poświęca się służbie ludziom. Jak wspomina brat Włodzimierz odwiedza chorych i ubogich, podaje lekarstwa, pociesza. Zdobywa wielkie zaufanie wśród ludzi w dalekiej okolicy. Przychodzili do niej z daleka aby zasięgnąć rady w wielu trudnościach i kłopotach, rozstrzygałą spory i łagodziła nieporozumienia. Nazywana była "niebieską panienką", a serce miała niezwykle wrażliwe i czułe. (brat)
W wieku 21 lat wstępuje do klasztoru Urszulanek w Krakowie 1920 osiedla się w Pniewach Zgromadzenie Urszulanek Serca Jezusa Konającego Zmarła w Rzymie 29 maja 1939 roku. Papież Jan Paweł II ogłosił ją błogosławioną 20 czerwca 1983 Zamiar Pana trwa na wieki; zamysły Jego serca poprzez pokolenia, aby ocalił ich życie od śmierci i żywił ich w czasie głodu.
` 
export const about = `
Św. Urszula Ledóchowska (1865–1939), urodzona jako Julia Ledóchowska, pochodziła z głęboko religijnej i patriotycznej rodziny. Urodziła się w Austrii, a młodość spędziła w Lipnicy Murowanej. W wieku 21 lat wstąpiła do urszulanek w Krakowie i przyjęła imię Urszula. Pracowała tam jako nauczycielka i wychowawczyni.

W 1907 roku wyjechała do Petersburga, gdzie prowadziła internat dla polskich dziewcząt i wspierała katolików w Rosji. Z powodu działań władz musiała opuścić kraj. Podczas I wojny światowej przebywała w Szwecji i Danii, gdzie działała charytatywnie i promowała sprawę Polski, wzbudzając sympatię dla narodu, który nie miał własnego państwa.

Po powrocie do Polski w 1920 roku założyła Zgromadzenie Sióstr Urszulanek Serca Jezusa Konającego, zwane „szarymi urszulankami”. Siostry zajmowały się wychowaniem dzieci i młodzieży oraz pracą społeczną. Główny dom zgromadzenia powstał w Pniewach.

Urszula prowadziła liczne dzieła wychowawcze i charytatywne, pisała książki i rekolekcje, była znana z dobroci, pogody ducha i odwagi. Zmarła 29 maja 1939 roku w Rzymie.

Została beatyfikowana w 1983 roku, a kanonizowana w 2003 roku przez Jana Pawła II. Dziś jest patronką wychowawców, ludzi młodych i osób pracujących społecznie.
`
export const photos = [
  "./assets/phoca_thumb_l_W wieku 21 lat.jpg",
  "./assets/phoca_thumb_l_M. Urszula w Petersburgu 1907.jpg",
  "./assets/phoca_thumb_l_W Rzymie.jpg"
];
export const prayers = [
  {
    title: "Litania do Świętej Urszuli Ledóchowskiej",
    text: `Kyrie Elejson, Chryste Elejson, Kyrie Elejson,
Chryste usłysz nas, Chryste wysłuchaj nas,
Ojcze z Nieba, Boże - zmiłuj się za nami,
Synu, Odkupicielu świata, Boże,....
Duchu Święty, Boże,....
Święta Trójco, Jedyny Boże,....

Święta Urszula Ledóchowska, Założycielka Zgromadzenia Sióstr Urszulanek Serca Jezusa Konającego
Święta Urszulo, która umiałaś wierzyć bez zastrzeżeń,
Święta Urszulo, która umiałaś miłować wśród doświadczeń,
Święta Urszulo, która umiałaś ufać wbrew nadziei,
Święta Urszulo, która wzrastałaś w promieniach Eucharystii,
Święta Urszulo, która u stóp Ukrzyżowanego czerpałaś siłę w cierpieniu,
Święta Urszulo, która uczyłaś się miłości w szkole Serca Jezusa Konającego,
Święta Urszulo, która umiałaś łączyć kontemplację z aktywnością,
Święta Urszulo, która umiałaś uświęcać szarą codzienność,
Święta Urszulo, wsłuchana w głos Ojca Niebieskiego i rozmiłowana w Jego woli,
Święta Urszulo, odpowiadająca miłością na: "Pragnę" Boskiego Odkupiciela,
Święta Urszulo, posłuszna natchnieniom Ducha Świętego,
Święta Urszulo, wierna córo Kościoła,
Święta Urszulo, mądra mistrzyni życia duchowego,
Święta Urszulo, odpowiedzialna przewodniczko wspólnoty zakonnej,
Święta Urszulo, troskliwa opiekunko sierot,
Święta Urszulo, miłująca wychowawczyni i nauczycielko dzieci i młodzieży,
Święta Urszulo, gorliwa apostołko dobroci i radości,
Święta Urszulo, oddana głoszeniu Dobrej Nowiny o zbawieniu,
Święta Urszulo, budująca braterską jedność wśród różnie myślących,
Święta Urszulo, szukająca wspólnej drogi z braćmi odłączonymi,
Święta Urszulo, zatroskana o przygotowanie robotników do pracy w winnicy Pana,
Święta Urszulo, wrażliwa na znaki czasu,
Święta Urszulo, wyczuwająca potrzeby chwili,
Święta Urszulo, współczująca z najbiedniejszymi,
Święta Urszulo, wpatrzona w Służebnicę Słowa Wcielonego.

Baranku Boży, Który gładzisz grzechy świata, przepuść nam, Panie,
Baranku Boży, Który gładzisz grzechy świata, wysłuchaj nas, Panie,
Baranku Boży, Który gładzisz grzechy świata, zmiłuj się nad nami.

Módlmy się:
Boże, Źródło i Dawco świętości, który uczyniłeś serce świętej Urszuli wrażliwym
na pragnienia serca Twego Umiłowanego Syna, spraw, abyśmy wspierani jej
orędownictwem umieli tak jak ona odczytywać znaki Twojej woli i odpowiadać na nie
żywą wiarą i czynem miłości. Wysłuchaj też łaskawie naszych próśb, zanoszonych
z ufnością za jej wstawiennictwem. Przez Chrystusa, Pana naszego. Amen.`,
  },
   {
    title: "Nowenna za wstawiennictwem św. Urszuli",
    text: `O Jezu, Sercu Twemu polecam… (tu wymienia się intencję)
Spojrzyj i uczyń to, co Ci Serce Twe wskaże.
Dozwól działać Twemu Sercu.
O Jezu, liczę na Ciebie, ufam Ci, oddaję Ci się zupełnie, jestem pewny(a) Ciebie.
O Serce pełne miłości, całą mą ufność pokładam w Tobie,
gdyż sam(a) z siebie zdolny(a) jestem do wszystkiego złego,
ale spodziewam się wszystkiego po Twojej dobroci. Amen.

Dla zasług Pana naszego Jezusa Chrystusa przyjmij, o Boże,
modlitwy zanoszone do Ciebie
za wstawiennictwem świętej Urszuli, wiernej naśladowczyni cnót
Najświętszego Serca Syna Twego,
i udziel nam łask, o które z ufnością prosimy. Amen.

Święta Urszulo, módl się za nami!`,
  },
  {
    title: "Modlitwa o pełnienie woli Bożej",
    text: "Chciałabym kochać Ciebie jak Maria Magdalena, która skrwawione nogi Twoje łzami miłości oblewała. Jak święty Jan, który spoczywał na Twoim Boskim Sercu. Czytam żywoty świętych, którzy tak blisko Ciebie żyli, z Tobą obcowali, którzy mieli tyle światła w modlitwie. A ja? Jestem zimna, oschła, ziemska, zatopiona w pracach, które wprawdzie zmierzają do Twej chwały i zbawienia dusz, czuję jednak, że dusza moja jest jak ziemia sucha i bezwodna. Tylko Ciebie kocham i kochać chcę i do Ciebie chcę należeć w zupełności, Panie mój! Ale sama z siebie nic nie mogę. Nic, tylko to jedno: oddać Ci bez zastrzeżeń swoją wolę, zamienić się w wolę Bożą! Gdy modlić się nie mogę, niech modlitwą moją będzie zupełne, stałe, chętne, pogodne zgadzanie się z wolą Bożą. Pokut ciężkich nie mogę odprawiać, ale niech pokutą moją będzie najzupełniejsze poddanie się woli Bożej, choćby ciężka i przykra dla natury była. Chcę kochać, lecz nie umiem. Serce moje zimne i obojętne. Najpewniejszym, najprawdziwszym aktem miłości niech więc będzie najdokładniejsze spełnianie woli Bożej wyrażonej w przykazaniach Boskich i kościelnych, a przede wszystkim w tym przykazaniu Pana Jezusa: \"Przykazanie nowe daję wam, abyście się wzajemnie miłowali, tak jak Ja was umiłowałem\"(J 13,34)"
  },
];
export const songs = [
  {
    title: "U Tronu Boga wstawiaj się za nami",
    text: `1. U tronu Boga wstawiaj się za nami,
święta Urszulo, wśród wybrańców nieba.
Ufni stajemy z naszymi prośbami,
ty wiesz jak bardzo łaski nam potrzeba.

2. Rodzinom uproś moc trwania przy Bogu,
młodzieży ufność wbrew wszelkiej nadziei.
Wyjednaj dziatwie, niech w rodzinnym progu
Bóg ją zachowa od grzechu zawiei.

3. Święta Urszulo, przed obliczem Pana
przemów za nami twe przemożne słowo.
Bóg cię wysłucha, niech łaska nam dana
odrodzi serca, zbudzi je na nowo.

4. Bądź uwielbiona Trójco Przenajświętsza,
Ojcze, nasz Stwórco, Synu Zbawicielu,
Duchu świętości, miłości i prawdy,
zawsze i wszędzie, i przez wszystkie wieki.`,
  },
   {
    title: "Ewangelia to Dobra Nowina",
    text: `1. Matko Urszulo Przeszłaś przez życie
z jasnym uśmiechem dobroci.
Naucz odnaleźć w szarych zajęciach
codzienną ścieżkę radości.

Ref.: Ewangelia to Dobra Nowina,
któą Jezus światu ogłosił.
Trzeba nieść ją wziąż dalej i dalej
całym życiem pełnym miłości.

2. Matko Urszulo, żyjąc z rozmachem
strzegłaś nauki Kościoła.
Naucz nas dzisiaj w czasach splątanych
iść tam, gdzie papież zawoła. Ref.

3. Matko Urszulo, kochałaś Serce
Jezusa Konającego.
Naucz z ochotą biec za Chrystusem,
wszystko oddawać dla Niego. Ref.
`
  },
]
export const quotes = [
  {
    text: "Kochane \"ja\" zawsze powodować będzie trudności, inaczej już być nie możem ale zaufajmy tylko i zawsze beztrosko tulmy się do Matki Bożej. Im bardziej uznamy naszą słabość, tym pewniej się poczujemy",
    source: "List do Marii Teresy Ledóchowskiej, Kraków, 30 VI 1890"
  },
  {
    text: "Gdyby ludzie wiedzieli, gdzie znaleźć odpoczynek, radość i pokój! Jak szczęśliwy mógłby być świat. Piękniejszy i wspanialszy od raju.",
    source: "List do Marii Teresy Ledóchowskiej, Kraków, 30 VI 1890"
  },
  {
    text: "Sądzę, że często większą zasługą jest wytrwać w spokoju niż podążać za własną wolą, nawet gdy w pierwszym przypadku wydaje się nam, że nic nie robimy, a w drugim - że moglibyśmy dużo uczynić. Niech Jego wola się dzieje, a reszta może nam być całkiem obojętna!",
    source: "List do Ilse von During, Lipnica, 14 II 1886",
  },
  {
    text: "Tylko zachowaj zawsze spokój duszy, nie trap się o nic, opieraj głowę swoją o Jego Boskie Serce, gdy Cię jakaś czarna myśl dręczy - tam jest uleczenie na każdą chorobę, na każdą boleść.",
    source: "List do Marii Teresy Ledóchowskiej, Lipnica, 10 I 1886",
  },
  {
    text: "Pokorne znoszenie własnych słabości, idące w parze z dziecięcym zaufaniem w Jego pomoc, bez której nic nie zdziałamy, przynosi pokój.",
    source: "List do Ilse von During, Lipnica, 13 I 1886",
  },
  {
    text: "Nie ma miłości bez ofiar.",
    source: "",
  },
  {
    text: "Przyjdzie znów i godzina łez - o tym nie wątp - więc proś Go teraz o potrzebne siły w chwilach smutku, a obecnie ciesz się w Bogu.",
    source: "List do Marii Teresy Ledóchowskiej, Lipnica, 20 XII 1885",
  },
  {
    text: "Niewielka zasługa robić to, co nam pociechę przynosi.",
    source: "",
  },
  {
    text: "Jakże można się smucić służąc takiemu Panu!",
    source: "List do Marii Teresy Ledóchowskiej, Lipnica, 15 VII 1885",
  },
  {
    text: "Przecież Pan Jezus szczególnie smutnych i niespokojnych do siebie woła, by ich pocieszyć.",
    source: "",
  },
  {
    text: "Kto mi da skrzydła gołębicy, bym uleciała, aby spocząć na łonie Boga? Niczego nie pragnę prócz Niego, poza Nim nie ma dla mnie szczęścia i wszystko wydaje mi się tak ciężkie, tak uciążliwe. Ale gdy się żyje wśród świata, nie można tak się wznieść, jakby dusza pragnęła.",
    source: "",
  },
  {
    text: "A proszę Cię, nie myśl za dużo o przyszłości - teraźniejszość ma dosyć i przykrości, i promieni słonecznych, jeżeli kto tylko chce im się bliżej przypatrzeć, by na niej poprzestać.",
    source: "",
  },
  {
    text: "W świecie trzeba bardziej niż w klasztorze odczuwać słodycz Krzyża.",
    source: "",
  },
  {
    text: "Spotykajmy się w każdej godzinie w Sercu naszego Zbawiciela - tam nie ma rozłąki.",
    source: "",
  },
  {
    text: "Najmniejsze obowiązki, wypełniane z radosną miłością są miłe Panu.",
    source: "",
  },
  {
    text: "Prawdziwa miłość polega na uczynkach i działaniu, a nie na uczuciu i przyjemnej satysfakcji, do której człowiek jest niestety skłonny.",
    source: "",
  },
  {
    text: "Miłość ma nas upajać, rozgrzewać, dodawać odwagi i odbierać wszelki przymus.",
    source: "",
  },
  {
    text: "Jeśli Ty kogoś kochasz, będziesz również kochać tych, którzy jemu są drodzy i im swą miłość okazywać, sprawiając radość i okazując szacunek tym, których on nad wszystko kocha.",
    source: "",
  },
  {
    text: "Gdy nikt nie potrafi pomóc, pomoże Maryja.",
    source: "",
  },
  {
    text: "Wszyscy jesteśmy słabi i nędzni, co dzień rozpoczynamy walkę i codziennie znowu upadamy, a to znaczy, że właśnie wtedy musimy jeszcze raz i jeszcze raz rozpocząć, aż dobry Bóg odwoła nas z placu boju i pozwoli wziąć udział w Jego pokoju.",
    source: "",
  },
  {
    text: "(...) nasza miłość ku Maryi jest najdelikatniejszym kwiatem Bożej miłości.",
    source: "",
  },
  {
    text: "Maryja jest najpiękniejszą myślą Boga, Jego arcydziełem, na które On, Wszechmocny, z najgłębszym upodobaniem spogląda i które z największej miłości nam dał, abyśmy je podziwiali, wychwalali, cenili i przez to uwielbiali Stwórcę.",
    source: "",
  },
  {
    text: "Pan Bóg pragnie, aby Jego dzieci służyły Mu z miłości i śpieszyły do Niego z radosnym sercem.",
    source: "",
  },
  {
    text: "Wszystko oddajmy z ufnością w ręce Ojca naszego. To, co dobre, znajdzie u Niego nagrodę, a to, co złe, spali się w ogniu miłości Boskiego Zbawcy - Stacja VII.",
    source: "Droga Krzyżowa",
  },
  {
    text: "Czy nie powinnam zrozumieć, że cierpienie jest dla miłości próbą, że im więcej ofiar, tym więcej miłości, że dla duszy, która kocha Jezusa Ukrzyżowanego, cierpienie rodzi szczęście... A może należymy do tych istot płaczliwych, słabych, które nawet małą przykrość, mały ból, mały krzyk oblewają gorzkimi łzami; które nie potrafią znieść na spokojnie trudności, jakie życie ze sobą przynosi; które uciekają przed każdym bólem, zmęczeniem, niewygodą? (Medytacje piątek po V niedzieli Wielkiego Postu)",
    source: "Medytacje",
  },
  {
    text: "Zawsze najpierw pamiętajcie o drugich, aby im było dobrze, wygodnie a potem dopiero o sobie. A najlepiej o sobie zupełnie zapomnijcie. Żyjcie jak Jezus, dla szczęścia innych.",
    source: "Testament III",
  },
  {
    text: "Dzieci najdroższe, bądźcie pokorne, nie szukajcie pochwał, uznania – im mniej pochwał, uznania od ludzi odbierzecie, tym większą chwałą Bóg w niebie Was otoczy.",
    source: "",
  },
  {
    text: "Czyż każdy opór nie musi ustąpić, gdy we wszelkich ludzkich rozporządzeniach i rozkazach dostrzega się kochającą rękę Boga?",
    source: "",
  },
];
